module.exports = __webpack_public_path__ + "img/scene-setting.f09c7d56.png";